var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-background vh-100"},[(this.$root.pin)?_c('div',[(!this.$root.isMobile)?_c('AccountsDesktop',{staticClass:"my-auto"}):_vm._e(),(this.$root.isMobile)?_c('AccountsMobile'):_vm._e(),_c('vue-snotify')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }